import { render } from "./ValoriParametriiSalarizare.vue?vue&type=template&id=cafe0492&scoped=true&ts=true"
import script from "./ValoriParametriiSalarizare.vue?vue&type=script&lang=ts"
export * from "./ValoriParametriiSalarizare.vue?vue&type=script&lang=ts"

import "./ValoriParametriiSalarizare.vue?vue&type=style&index=0&id=cafe0492&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cafe0492"]])

export default __exports__